'use client';

import React, { useState } from 'react';
import Button, { Variants } from '../../_ui/Buttons/Button/Button';
import CreateReportModal from '../CreateReportModal';
import Modal from '../../_ui/Modals/Modal/Modal';

interface Props {
    buttonVariant?: keyof typeof Variants;
}

const CreateReportModalButton = ({ buttonVariant = "primarySolid" }: Props) => {
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);

    return (
        <>
            <Button
                variant={buttonVariant}
                icon="download"
                onClick={() => setIsReportModalOpen(true)}
            >
                Create Report
            </Button>
            <Modal show={isReportModalOpen} onClose={() => setIsReportModalOpen(false)}>
                <CreateReportModal onClose={() => setIsReportModalOpen(false)} />
            </Modal>
        </>
    );
};

export default CreateReportModalButton;
